"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = require("HubStyleTokens/colors");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var UITextToolbarIcon = (0, _styledComponents.default)(_UIIcon.default).attrs({
  size: 14
}).withConfig({
  displayName: "UITextToolbarIcon",
  componentId: "pzdsap-0"
})(["color:", ";"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? _colors.BUTTON_DISABLED_TEXT : _colors.HEFFALUMP;
});
UITextToolbarIcon.propTypes = {
  disabled: _propTypes.default.bool,
  name: _UIIcon.default.propTypes.name
};
var _default = UITextToolbarIcon;
exports.default = _default;
module.exports = exports.default;